import dynamic from 'next/dynamic';

import useAdditionalMenu from '~/shared/components/header/components/additional-menu/use-additional-menu';
import IconToggle from '~/shared/components/header/components/icon-toggle';
import LanguageSwitcher from '~/shared/components/header/components/language-switcher';
import MenuIcon from '~/shared/components/header/components/menu-icon/menu-icon';
import Search from '~/shared/components/header/components/search';
import ThemeSwitcher from '~/shared/components/header/components/theme-switcher';
import { LargeTabletMedia, MobileMedia, TabletDesktopMedia } from '~/shared/components/media-query';
import type { Locale } from '~/shared/constants';
import { getDeviceInfo } from '~/shared/helpers/get-device-info';
import type { ShortUserType } from '~/shared/types/user-type';

import './additional-menu.scss';

const MenuBar = dynamic(() => import('../menu-bar'), {
  ssr: false,
});

type AdditionalMenuProps = Readonly<{
  lng: Locale;
  user: ShortUserType | null;
  setIsMainMenuToggled: (status: boolean) => void;
  onSignOutCallback?: () => void;
  isPlatformNavigationHidden?: boolean;
}>;

const AdditionalMenu = ({
  lng,
  onSignOutCallback,
  user,
  setIsMainMenuToggled,
  isPlatformNavigationHidden = false,
}: AdditionalMenuProps) => {
  const { isAdminPanel, isPlatform, isClientsPanel } = useAdditionalMenu();
  const device = getDeviceInfo();
  const menuToggle = (
    <div className="additional-menu__menu-button">
      <div onClick={() => setIsMainMenuToggled(true)} className="additional-menu__additional-menu-icon">
        <MenuIcon />
      </div>
    </div>
  );

  return (
    <div className="additional-menu">
      {!isAdminPanel && !isPlatform && !isClientsPanel ? <Search lng={lng} /> : null}

      <div className="additional-menu__theme-switcher">
        <ThemeSwitcher />
      </div>

      <div className="additional-menu__language-switcher">
        <LanguageSwitcher lng={lng} />
      </div>

      {!device.isMobileDevice && (
        <TabletDesktopMedia>
          <MenuBar onSignOutCallback={onSignOutCallback} lng={lng} user={user} />
        </TabletDesktopMedia>
      )}

      {!device.isMobileDevice && (
        <TabletDesktopMedia>
          {!isAdminPanel && !isPlatform && !isClientsPanel ? <IconToggle lng={lng} /> : null}
        </TabletDesktopMedia>
      )}
      {device.isMobileDevice && menuToggle}
      {!device.isMobileDevice &&
        (isPlatformNavigationHidden ? (
          <LargeTabletMedia>{menuToggle}</LargeTabletMedia>
        ) : (
          <MobileMedia>{menuToggle}</MobileMedia>
        ))}
    </div>
  );
};

export default AdditionalMenu;
